import React from "react";
import PropTypes from "prop-types";
import { SectionHeader } from "components/molecules";
import PspLinkCard from "../PspLinkCard/PspLinkCard";

import "./PspLinks.scss";

export default function PspLinks({ storageGridContent }) {
	return (
		<section className="psp-links-container">
			<SectionHeader
				title={storageGridContent.title}
				image={storageGridContent.image}
				contentAlign="text-center"
				titleProps={{
					size: "xxlarge",
					weight: "bold",
					color: "black",
					style: { padding: 0 }
				}}
				className="title"
				isPageContainer={false}
			/>
			<div className="psp-links-grid">
				{storageGridContent.storageTypes.map((storage) => (
					<PspLinkCard
						key={storage.id}
						image={storage.image}
						title={storage.title}
						description={storage.description}
						link={storage.link}
					/>
				))}
			</div>
		</section>
	);
}

PspLinks.propTypes = {
	storageGridContent: PropTypes.shape({
		title: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
		storageTypes: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
					.isRequired,
				title: PropTypes.string.isRequired,
				description: PropTypes.string.isRequired,
				image: PropTypes.string.isRequired,
				link: PropTypes.string.isRequired
			})
		).isRequired
	}).isRequired
};
